<template>
  <div
    class="rounded"
    :style="`border: 2px ${errors.length > 0 ? 'var(--v-error-base)' : '#e5e7eb'} dashed !important`"
  >
    <file-pond
      ref="pond"
      :name="inputName"
      :label-idle="labelIdle"
      :allow-multiple="allowMultiple"
      :allow-image-preview="allowImagePreview"
      :allow-browse="allowBrowse"
      :accepted-file-types="acceptedFileTypes"
      :files="initialFiles"
      :store-as-file="storeAsFile"
      :required="required"
      style-panel-layout="integrated"
      @input="onInput"
      @addfile="onAddFile"
      @updatefiles="onUpdateFiles"
      @removefile="onRemoveFile"
    />
  </div>
</template>

<script>
import vueFilePond from 'vue-filepond'
import 'filepond/dist/filepond.min.css'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'

const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview
)

export default {
  name: 'DropzoneField',
  components: {
    FilePond
  },
  props: {
    inputName: {
      type: String,
      default: 'file'
    },
    allowMultiple: {
      type: Boolean,
      default: false
    },
    allowBrowse: {
      type: Boolean,
      default: true
    },
    allowImagePreview: {
      type: Boolean,
      default: true
    },
    storeAsFile: {
      type: Boolean,
      default: true
    },
    required: {
      type: Boolean,
      default: false
    },
    labelIdle: {
      type: String,
      default: 'Drop files here...'
    },
    acceptedFileTypes: {
      type: String,
      default: 'image/jpeg, image/png'
    },
    initialFiles: {
      type: Array,
      default: undefined
    },
    value: {
      required: true,
      validator: prop => ['object', 'array'].indexOf(typeof prop) > -1 || prop === null
    },
    errors: {
      type: Array,
      default: null
    }
  },
  methods: {
    onAddFile(errorObject, fileObj) {
      if (!errorObject) {
        this.$emit('input', fileObj.file)
      }
    },
    onInput(files) {
      //
    },
    onUpdateFiles(file) {
      //
    },
    onRemoveFile(errorObject, file) {
      //
    }
  }
}
</script>

<style lang="scss">
.filepond--credits {
  visibility: hidden;
  opacity: 0;
  display: none;
}
</style>
